module.exports = __webpack_public_path__ + "img/m-hd.ae78e78e.webp";